/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import Imgix from 'js/components/Imgix';

import { Link, Typography2, breakpoints } from '@coursera/cds-core';

import imgixParams from 'bundles/page/common/imgixParams';
import { TrackedA } from 'bundles/page/components/TrackedLink2';

const styles = {
  container: css`
    display: flex;
    flex-direction: row;
    background-color: var(--cds-color-neutral-background-primary);
    border: 1px solid var(--cds-color-grey-200);
    margin-bottom: var(--cds-spacing-150);
    padding: var(--cds-spacing-150);
    cursor: pointer;
    overflow: hidden;

    &:hover {
      background-color: var(--cds-color-grey-25);
    }
  `,
  horizontalBox: css`
    display: flex;
    align-items: baseline;
  `,
  image: css`
    ${breakpoints.down('sm')} {
      width: var(--cds-spacing-1400);
      height: var(--cds-spacing-1400);
    }
  `,
  info: css`
    gap: var(--cds-spacing-100);
    width: 100%;
    margin: 0 var(--cds-spacing-150);
  `,

  name: css`
    flex: 1;
    line-height: var(--cds-spacing-300);
    margin: var(--cds-spacing-100) 0;

    ${breakpoints.down('xs')} {
      margin-top: 0;
    }
  `,
  availability: css`
    ${breakpoints.down('xs')} {
      display: none;
    }
  `,
};

type Props = {
  name: string;
  slug: string;
  logo: string;
  tagline?: string;
  availability?: string;
};

const FullWidthCard = ({ logo, name, tagline, slug, availability }: Props) => {
  return (
    <Link css={styles.container} variant="standard" component={TrackedA} href={slug} trackingName="link_to_sdp">
      <div>
        <Imgix
          css={styles.image}
          src={logo || ''}
          imgParams={imgixParams.fillWithWhiteBackground}
          maxWidth={100}
          maxHeight={100}
          alt={name}
        />
      </div>
      <div css={styles.info}>
        <div css={styles.horizontalBox}>
          <Typography2 css={styles.name} component="p" variant="subtitleLarge">
            {name}
          </Typography2>
          <Typography2 css={styles.availability} component="p" variant="bodySecondary">
            {availability}
          </Typography2>
        </div>
        <div>
          <Typography2 component="p" variant="bodySecondary">
            {tagline}
          </Typography2>
        </div>
      </div>
    </Link>
  );
};

export default FullWidthCard;
